import * as React from "react";
import { IconBase, IIconBase } from "src/icons/IconBase";

export const FallbackIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Wrench</title>
    <path d="M40,10.12l-4,4-5-5,4-4-1-2H30l-4,4v7l-20,20v3l2,2h3l20-20h7l4-4v-4Z" />
  </IconBase>
);
